<template>
    <div>
        <el-dropdown trigger="click" @command="changeLanguage" style="cursor: pointer">
            <span class="el-dropdown-link">
            <div :class="selectedLanguage.flagClass ?  selectedLanguage.flagClass: '' "></div>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in possibleLanguages"
                                  :key="item.flagClass"
                                  :label="item.flagClass"
                                  :command="item">
                    <div :class="item.flagClass"></div>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>


    </div>
</template>

<script>
    import mutations from "../../utils/store/mutations";

    export default {
        name: "languageSelector",
        data: function () {
            return {
                possibleLanguages: [
                    {
                        language: "es",
                        flagClass: "flag-icon flag-icon-es"
                    },
                    {
                        language: "pt",
                        flagClass: "flag-icon flag-icon-pt"
                    },
                    {
                        language: "en",
                        flagClass: "flag-icon flag-icon-gb"
                    }],
                selectedLanguage: {}
            }
        },
        mounted() {
            let language = undefined;
            if (this.$store.state.language !== undefined) {
                language = this.possibleLanguages.find(value => {
                    return value.language === this.$store.state.language;
                })
            }

            this.selectedLanguage = language === undefined ? this.possibleLanguages[0] : language;

        },
        methods: {
            changeLanguage(lang) {
                this.selectedLanguage = lang;
                this.$i18n.locale = lang.language;
                this.$store.commit(mutations.CHANGE_LANGUAGE, lang.language);
                window.location.reload();

            }
        }
    }
</script>

<style scoped>

</style>